import { ApiMutationConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { urlPart } from 'data';

const organizationsUrl = `${URLS.app}/api/organizations`;

type PostIntegrationRegistrationV1PathParams = {
  $workspaceId: urlPart;
};

type PostIntegrationRegistrationV1Config = ApiMutationConfig<
  number,
  PostIntegrationRegistrationV1PathParams,
  void
>;

export const putIntegrationRegistrationV1 =
  createApiEndpoint<PostIntegrationRegistrationV1Config>({
    url: `${organizationsUrl}/$workspaceId/integration`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  });
